import React from "react";
import logo from "../images/logo-bookmark.svg";
function Header(){
    return(
        <div className="header-area">           
            <img src={logo} alt="bookmark" className="logo" />
            <div className="menu-bar">
                <ul>
                    <li>features </li>
                    <li>Pricing</li>
                    <li>Contact</li>
                    <li><button>login</button></li>
                </ul>
            </div>
        </div>
    )

}
export default Header;